class ConferenciaNfeFilter {
    static get $inject() {
        return ['$scope']
    }

    constructor(scope) {
        const today = new Date()

        this.filter = {
            emissaoExterna: true,
            periodo: {
                inicial: new Date(today.getFullYear(), today.getMonth(), 1),
                final: today
            }
        }

        scope.$watch(() => this.filter, () => this.submit(), true)
    }

    submit() {
        if (this.form && this.form.$valid)
            this.updateFilter()
    }

    updateFilter() {
        const filter = angular.copy(this.filter)

        cbk.deleteEmptyKeys(filter)

        if (filter.periodo) {
            if (filter.periodo.inicial)
                filter.emissaoInicial = filter.periodo.inicial.toISOString()

            if (filter.periodo.final)
                filter.emissaoFinal = filter.periodo.final.toISOString()
        }

        delete filter.periodo

        if (filter.numero || filter.chave) {
            delete filter.emissaoInicial
            delete filter.emissaoFinal
        }

        this.onChange({ $newFilter: filter })
    }
}

angular.module('eficienciaFiscalModule')
    .component('conferenciaNfeFilter', {
        controller: ConferenciaNfeFilter,
        bindings: {
            'onChange': '&'
        },
        template: `
        <form class="fade-animation" name="$ctrl.form" ng-submit="$ctrl.submit()">
            <div class="row">
                <div class="form-group col-sm-5 col-md-4">
                    <label>
                        Data de emissão
                        <i
                            class="fa fa-trash-o text-danger cursor-pointer" 
                            ng-click="$ctrl.filter.periodo = undefined"
                            ng-if="$ctrl.filter.periodo">
                        </i>
                    </label>
                    <periodo-input name="emissao" ng-model="$ctrl.filter.periodo"></periodo-input>
                </div>

                <div class="form-group col-sm-2">
                    <label>
                        Número
                        <i
                            class="fa fa-trash-o text-danger cursor-pointer" 
                            ng-click="$ctrl.filter.numero = undefined"
                            ng-if="$ctrl.filter.numero">
                        </i>
                    </label>
                    <input type="text" class="form-control" ng-model="$ctrl.filter.numero" ng-model-options="{ debounce: 500 }">
                </div>

                <div class="form-group col-sm-5 col-md-6">
                    <label>
                        Chave
                        <i
                            class="fa fa-trash-o text-danger cursor-pointer" 
                            ng-click="$ctrl.filter.chave = undefined"
                            ng-if="$ctrl.filter.chave">
                        </i>
                    </label>
                    <input type="text" class="form-control" ng-model="$ctrl.filter.chave" ng-model-options="{ debounce: 500 }">
                </div>

                <div class="form-group col-sm-3 col-lg-3">
                    <label>
                        Número do lançamento
                        <i
                            class="fa fa-trash-o text-danger cursor-pointer" 
                            ng-click="$ctrl.filter.numeroExtrato = undefined"
                            ng-if="$ctrl.filter.numeroExtrato">
                        </i>
                    </label>
                    <input type="text" class="form-control" ng-model="$ctrl.filter.numeroExtrato" ng-model-options="{ debounce: 500 }">
                </div>

                <div class="form-group col-sm-6">
                    <label>
                        Emitente
                        <i
                            class="fa fa-trash-o text-danger cursor-pointer" 
                            ng-click="$ctrl.filter.emitente = undefined"
                            ng-if="$ctrl.filter.emitente">
                        </i>
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Razão Social, CNPJ"
                        ng-model="$ctrl.filter.emitente"
                        ng-model-options="{ debounce: 500 }">
                </div>

                <div class="form-group col-sm-3">
                    <label>
                        Status da conferência
                        <i
                            class="fa fa-trash-o text-danger cursor-pointer" 
                            ng-click="$ctrl.filter.tributacaoStatus = undefined"
                            ng-if="$ctrl.filter.tributacaoStatus != undefined">
                        </i>
                    </label>
                    <select class="form-control" ng-model="$ctrl.filter.tributacaoStatus">
                        <option value="">Todas</option>
                        <option value="PENDENTE">Aguardando lançamento</option>
                        <option value="CONFIAVEL">Valores corretos</option>
                        <option value="DIVERGENTE">Valores divergentes</option>
                    </select>
                </div>

                <div class="form-group col-sm-3">
                    <label class="hidden-xs">&nbsp;</label>
                    <button type="submit" class="btn btn-primary btn-block">
                        <i class="fa fa-refresh"></i>
                        Atualizar
                    </button>
                </div>
            </div>
        </form>
        `
    })
